import { FC } from 'react'

import { DialogBackdrop } from 'ui/components/Dialog/styles'

import { ControlInfo, ResultsList, SearchInput } from './components'
import { useGlobalSearch } from './hooks/useGlobalSearch'

import { s } from './styles'

export const SearchDialog: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { dialogRef, searchText, handleChange, clearSearch, hasQueried, results, isLoading } = useGlobalSearch(onClose)

  return (
    <DialogBackdrop tabIndex={1}>
      <s.Box ref={dialogRef}>
        <SearchInput isLoading={isLoading} value={searchText} onChange={handleChange} clearSearch={clearSearch} />
        <ResultsList
          searchText={searchText}
          results={results}
          isLoading={isLoading}
          hasQueried={hasQueried}
          onClose={onClose}
        />
        <ControlInfo />
      </s.Box>
    </DialogBackdrop>
  )
}
